/**
 * tourSteps/sprintSteps.js
 * Comprehensive tour steps for the Agile Sprint Management & Cadence view.
 */

export const sprintSteps = [
    {
        title: 'Sprint Cycle Management',
        description: 'Track time-boxed agile sprint cycles. Manage active commitments, monitor delivery velocity, and align cross-functional teams around sprint goals.',
        selector: '[data-tour="sprint-header"]',
        placement: 'bottom',
    },
    {
        title: 'Sprint Selector & History',
        description: 'Switch between current active sprints, upcoming planned cycles, and historical closed sprints using the sprint selection dropdown.',
        selector: '[data-tour="sprint-selector-dropdown"]',
        fallbackSelector: '[data-tour="sprint-header"]',
        placement: 'bottomRight',
    },
    {
        title: 'Sprint Cadence & AI Settings',
        description: 'Configure sprint duration (1 to 4 weeks), cycle start day, public holiday calendar exclusions, and automated AI sprint reporting options.',
        selector: '[data-tour="sprint-settings-btn"]',
        fallbackSelector: '[data-tour="sprint-header"]',
        placement: 'bottomRight',
    },
    {
        title: 'Sprint Health & Velocity KPIs',
        description: 'Real-time computed metrics: Days remaining in cycle, committed work items, story point burndown, team velocity, and completion percentage.',
        selector: '[data-tour="sprint-kpi-cards"]',
        placement: 'bottom',
    },
    {
        title: 'Sprint Task Stream',
        description: 'Tasks strictly scoped to this sprint timeframe, grouped by status pipeline with quick status updates and task detail access.',
        selector: '[data-tour="sprint-timeline"]',
        placement: 'top',
    },
    {
        title: 'AI Sprint Intelligence & Risk Forecasting',
        description: 'Continuous AI insights forecasting sprint completion probability, flagging high-risk tasks, and highlighting blockers that need managerial intervention.',
        selector: '[data-tour="sprint-insights-panel"]',
        placement: 'left',
    },
    {
        title: 'Sprint Progress Report & Archival',
        description: 'Review completion rate, automatically roll unfinished tasks into the next sprint cycle, close the sprint, and generate the executive Sprint Report.',
        selector: '[data-tour="sprint-progress-report"]',
        placement: 'top',
    },
];
